<template>
    <b-modal
        id="test-issuing-manager-modal"
        v-model="modal"
        :title="$t('testcenter.manage_administrators')"
        :ok-title="$t('common.save')"
        @ok="save($event)"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        modal-class="apprentice-default-modal"
        dusk="test-issuing-manager-modal">
        <div>
            {{ $t('testcenter.remove_self_from_test_warning') }}
            <b-form-group
                class="teacher-selector"
                label-for="teacher-multiselect"
                label="Docenten">
                <design-2021-apprentice-multiselect-component
                    id="student-multiselect"
                    v-model="selectedTeachers"
                    label="full_name"
                    :options="teachers"
                    track-by="id"
                    :allow-empty="false"
                    :multiple-select="true">
                </design-2021-apprentice-multiselect-component>
            </b-form-group>
        </div>
    </b-modal>
</template>
<script>
import Design2021ApprenticeMultiselectComponent from '../../common/design-2021-apprentice-multiselect-component.vue';

export default {
    name: 'design-2021-test-issuing-share-modal-component',
    components: { Design2021ApprenticeMultiselectComponent },
    props: {
        testIssuingIn: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            modal: false,
            loaded: false,
            teachers: [],
            selectedTeachers: this.testIssuingIn.teachers,
        };
    },
    computed: {},
    methods: {
        show() {
            if (!this.loaded) {
                this.axios.get(this.routes.getTeachers()).then(
                    (response) => {
                        this.teachers = response.data;
                        this.loaded = true;
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
            }
            this.selectedTeachers = this.testIssuingIn.teachers;
            this.modal = true;
        },
        save() {
            this.alert.saving();
            let data = {
                teacher_ids: this.selectedTeachers.map((teacher) => teacher.id),
            };
            this.axios.post(this.routes.testIssuingSubmitTeachers(this.testIssuingIn.id), data).then(
                (response) => {
                    this.$emit('updateTeachers', response.data);
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>
<style scoped lang="scss"></style>
